// [2026-10-29] ปุ่มธงเลือกภาษา 5 ภาษา (ใช้แทนช่อง Language / ภาษา เดิมที่มีแค่ธงไทย)
import React from 'react';
import { LANGS, getLang, setLang } from './i18nAuto';

export default class LangFlags extends React.Component {
  state = { lang: getLang() };
  componentDidMount() { window.addEventListener('site-lang', this.onLang); }
  componentWillUnmount() { window.removeEventListener('site-lang', this.onLang); }
  onLang = (e) => this.setState({ lang: (e && e.detail) || getLang() });
  render() {
    const { lang } = this.state;
    return (
      <ul className={'logo-list-footer ' + (this.props.className || '')} data-noi18n="1"
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, padding: 0, margin: '6px 0 0' }}>
        {LANGS.map((l) => (
          <li key={l.code} role="button" title={l.label} onClick={() => setLang(l.code)}
            style={{ listStyle: 'none', cursor: 'pointer', textAlign: 'center', opacity: lang === l.code ? 1 : 0.55 }}>
            <img className={'lang-img' + (lang === l.code ? ' active-lang' : '')} src={l.img} alt={l.label}
              style={{ width: 34, height: 24, objectFit: 'cover', borderRadius: 4, border: lang === l.code ? '2px solid var(--primary,#fbc844)' : '2px solid transparent' }} />
            <div style={{ fontSize: 11, color: '#fff', marginTop: 2, fontWeight: lang === l.code ? 700 : 400 }}>{l.short}</div>
          </li>
        ))}
      </ul>
    );
  }
}
